import { Link } from 'react-router-dom';
import { animeArticles } from '@/mocks/anime';

const popularAnime = animeArticles.sort((a, b) => b.views - a.views).slice(0, 8);

export default function FeaturedAnime() {
  return (
    <section className="py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精选最受动漫迷欢迎的热门作品，每一部都值得反复品味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {popularAnime.map((anime) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3">
                <div className="aspect-[3/4] w-full">
                  <img
                    src={anime.coverImage}
                    alt={anime.title}
                    title={`${anime.title} - 樱花动漫`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {anime.rating}分
                  </span>
                </div>
                {anime.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {anime.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {anime.categoryName} · {anime.episodes}
              </p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-2 px-6 py-2.5 border-2 border-primary-500 text-primary-500 text-sm font-medium rounded-full hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多热门动漫
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}